import images_new from "./images_new.js";
export default {
  heating: {
    1: require("../src/assets/images/geometrija/grejanje/Grejanje_OIL.svg"),
    2: require("../src/assets/images/geometrija/grejanje/Grejanje_HEATING_GAS.svg"),
    3: require("../src/assets/images/geometrija/grejanje/Grejanje_COAL.svg"),
    4: require("../src/assets/images/geometrija/grejanje/Grejanje_WOOD.svg"),
    5: require("../src/assets/images/geometrija/grejanje/Grejanje_ELECTRICITY.svg"),
    6: require("../src/assets/images/geometrija/grejanje/Grejanje_DISTANT_HEATING.svg"),
    7: require("../src/assets/images/geometrija/grejanje/Grejanje_COGENERATION.svg"),
    8: require("../src/assets/images/geometrija/grejanje/Grejanje_GROUND_HEATING.svg"),
    9: require("../src/assets/images/geometrija/grejanje/Grejanje_PELETTES.svg"),
    10: require("../src/assets/images/geometrija/grejanje/Grejanje_KEROSENE.svg"),
    11: require("../src/assets/images/geometrija/grejanje/Grejanje_BIRIKETI.svg"),
    12: require("../src/assets/images/geometrija/grejanje/Grejanje_ANTRACIT.svg"),
    13: require("../src/assets/images/geometrija/grejanje/Grejanje_LIGNIT.svg"),
    14: require("../src/assets/images/geometrija/grejanje/Grejanje_SPLIT_SYSTEM.svg"),
    15: require("../src/assets/images/geometrija/grejanje/Grejanje_MAZUT.svg"),
    16: require("../src/assets/images/geometrija/grejanje/Grejanje_PROPANE.svg"),
  },
  pos_house: {
    hahb_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-03.png"),
    hanhb_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-02.png"),
    hat_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-06.png"),
    nhahb_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-04.png"),
    nhanhb_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-01.png"),
    nhat_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-05.png"),
    phb_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-09.png"),
    pnhb_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-08.png"),
    pt_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-07.png"),
    ao_1: require("../src/assets/images/konstrukcija/house/KUCE-CROP-10.png"),
    hahb_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-03.png"),
    hanhb_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-02.png"),
    hat_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-06.png"),
    nhahb_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-04.png"),
    nhanhb_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-01.png"),
    nhat_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-05.png"),
    phb_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-09.png"),
    pnhb_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-08.png"),
    pt_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-07.png"),
    ao_2: require("../src/assets/images/konstrukcija/house/KUCE-CROP-10.png"),
    hahb_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-03.png"),
    hanhb_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-02.png"),
    hat_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-06.png"),
    nhahb_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-04.png"),
    nhanhb_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-01.png"),
    nhat_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-05.png"),
    phb_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-09.png"),
    pnhb_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-08.png"),
    pt_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-07.png"),
    ao_3: require("../src/assets/images/konstrukcija/house/KUCE-CROP-10.png"),
    hahb_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-03.png"),
    hanhb_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-02.png"),
    hat_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-06.png"),
    nhahb_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-04.png"),
    nhanhb_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-01.png"),
    nhat_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-05.png"),
    phb_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-09.png"),
    pnhb_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-08.png"),
    pt_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-07.png"),
    ao_4: require("../src/assets/images/konstrukcija/house/KUCE-CROP-10.png"),
  },
  typ_house: {
    hahb_1: require("../src/assets/images/geometrija/house/KUCE-03.png"),
    hanhb_1: require("../src/assets/images/geometrija/house/KUCE-02.png"),
    hat_1: require("../src/assets/images/geometrija/house/KUCE-06.png"),
    nhahb_1: require("../src/assets/images/geometrija/house/KUCE-04.png"),
    nhanhb_1: require("../src/assets/images/geometrija/house/KUCE-01.png"),
    nhat_1: require("../src/assets/images/geometrija/house/KUCE-05.png"),
    phb_1: require("../src/assets/images/geometrija/house/KUCE-09.png"),
    pnhb_1: require("../src/assets/images/geometrija/house/KUCE-08.png"),
    pt_1: require("../src/assets/images/geometrija/house/KUCE-07.png"),
    ao_1: require("../src/assets/images/geometrija/house/KUCE-10.png"),
    hahb_2: require("../src/assets/images/geometrija/house/KUCE-03.png"),
    hanhb_2: require("../src/assets/images/geometrija/house/KUCE-02.png"),
    hat_2: require("../src/assets/images/geometrija/house/KUCE-06.png"),
    nhahb_2: require("../src/assets/images/geometrija/house/KUCE-04.png"),
    nhanhb_2: require("../src/assets/images/geometrija/house/KUCE-01.png"),
    nhat_2: require("../src/assets/images/geometrija/house/KUCE-05.png"),
    phb_2: require("../src/assets/images/geometrija/house/KUCE-09.png"),
    pnhb_2: require("../src/assets/images/geometrija/house/KUCE-08.png"),
    pt_2: require("../src/assets/images/geometrija/house/KUCE-07.png"),
    ao_2: require("../src/assets/images/geometrija/house/KUCE-10.png"),
    hahb_3: require("../src/assets/images/geometrija/house/KUCE-03.png"),
    hanhb_3: require("../src/assets/images/geometrija/house/KUCE-02.png"),
    hat_3: require("../src/assets/images/geometrija/house/KUCE-06.png"),
    nhahb_3: require("../src/assets/images/geometrija/house/KUCE-04.png"),
    nhanhb_3: require("../src/assets/images/geometrija/house/KUCE-01.png"),
    nhat_3: require("../src/assets/images/geometrija/house/KUCE-05.png"),
    phb_3: require("../src/assets/images/geometrija/house/KUCE-09.png"),
    pnhb_3: require("../src/assets/images/geometrija/house/KUCE-08.png"),
    pt_3: require("../src/assets/images/geometrija/house/KUCE-07.png"),
    ao_3: require("../src/assets/images/geometrija/house/KUCE-10.png"),
    hahb_4: require("../src/assets/images/geometrija/house/KUCE-03.png"),
    hanhb_4: require("../src/assets/images/geometrija/house/KUCE-02.png"),
    hat_4: require("../src/assets/images/geometrija/house/KUCE-06.png"),
    nhahb_4: require("../src/assets/images/geometrija/house/KUCE-04.png"),
    nhanhb_4: require("../src/assets/images/geometrija/house/KUCE-01.png"),
    nhat_4: require("../src/assets/images/geometrija/house/KUCE-05.png"),
    phb_4: require("../src/assets/images/geometrija/house/KUCE-09.png"),
    pnhb_4: require("../src/assets/images/geometrija/house/KUCE-08.png"),
    pt_4: require("../src/assets/images/geometrija/house/KUCE-07.png"),
    ao_4: require("../src/assets/images/geometrija/house/KUCE-10.png"),
    hahb_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-03.png"),
    hanhb_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-02.png"),
    hat_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-06.png"),
    nhahb_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-04.png"),
    nhanhb_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-01.png"),
    nhat_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-05.png"),
    phb_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-09.png"),
    pnhb_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-08.png"),
    pt_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-07.png"),
    ao_d1: require("../src/assets/images/geometrija/desktop_house/KUCE-10.png"),
    hahb_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_03.png"),
    hanhb_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_02.png"),
    hat_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_06.png"),
    nhahb_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_04.png"),
    nhanhb_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_01.png"),
    nhat_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_05.png"),
    phb_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_09.png"),
    pnhb_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_08.png"),
    pt_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_07.png"),
    ao_d2: require("../src/assets/images/geometrija/desktop_house/KUCE_10.png"),
  },
  sklopovi_a: images_new.sklopovi_a,
  sklopovi_b: images_new.sklopovi_b,
  sklopovi_c: images_new.sklopovi_c,
};
